import { useCallback, useMemo } from 'react';

export const AVAILABLE_SESSION_KEYS = ['careNavigation_patientNin'] as const;
export type AvailableSessionKey = (typeof AVAILABLE_SESSION_KEYS)[number];

export function useStorage(key: AvailableSessionKey) {
	const SESSION_STORAGE_KEY = key;

	const set = useCallback(
		(nin: string | null) => {
			if (nin !== null) {
				sessionStorage.setItem(SESSION_STORAGE_KEY, nin);
			}
		},
		[SESSION_STORAGE_KEY],
	);

	const get = useCallback(() => {
		return sessionStorage.getItem(SESSION_STORAGE_KEY) ?? null;
	}, [SESSION_STORAGE_KEY]);

	const remove = useCallback(() => {
		sessionStorage.removeItem(SESSION_STORAGE_KEY);
	}, [SESSION_STORAGE_KEY]);

	return useMemo(
		() => ({
			set,
			get,
			AVAILABLE_SESSION_KEYS,
			remove,
		}),
		[set, get, remove],
	);
}
